import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import DataCard from '../ViewPageDataModel/DataCard';
import UnusedDataCard from './UnusedDataCard';

const ProjectDataModelCanvas = (props) => {
  const { selectedProject, loadPages, setLoadPages } = props;
  const [uniqueDataElements, setUniqueDataElements] = useState([]);
  const [unusedEntitiesNames, setUnusedEntitiesNames] = useState([]);
  let usedEntitiesNames = [];

  useEffect(() => {

    let dataElements = [];
    if (!selectedProject || selectedProject < 0 || loadPages === false) return;
    dataElements = JSON.parse(localStorage.getItem('data'))[selectedProject].pages.map((page) => page.data)
      .reduce((acc, curVal) =>  acc.concat(curVal), [])
      .reduce((uniqueData, data) => {
        if (uniqueData && data !== undefined) {

          if(uniqueData.get(data.dataName) !== undefined){
            const newSchema = data.schema.concat(uniqueData.get(data.dataName).schema);
            const entryNames = newSchema.map( o => o.entryName);
            const filteredNewSchema = newSchema.filter( ({entryName},index) => !entryNames.includes(entryName,index+1))

            const newActions = data.actions.concat(uniqueData.get(data.dataName).actions);
            const actionNames = newActions.map( o => o.actionName);
            const filterNewActions = newActions.filter( ({actionName},index) => !actionNames.includes(actionName,index +1));

            uniqueData.set(data.dataName, {
              ...uniqueData.get(data.dataName),
              schema: filteredNewSchema,
              actions: filterNewActions
            });
          }
          else{
            uniqueData.set(data.dataName, {
              attributeName: data.attributeName,
              schema: data.schema,
              actions: data.actions
            });
          }
        } else if( data !== undefined) {
          uniqueData.set(data.dataName, {
            ...uniqueData.get(data.dataName),
            schema: data.schema.concat(uniqueData.get(data.dataName).schema),
            actions: data.actions.concat(uniqueData.get(data.dataName).actions)
          });
        }
        return uniqueData;
      }, new Map());

      setUniqueDataElements([...dataElements.values()]);
    usedEntitiesNames = Array.from(dataElements.values()).map( data => data.attributeName);
    let allEntities = JSON.parse(localStorage.getItem('data'))[selectedProject].annotations[0] !== undefined ? JSON.parse(localStorage.getItem('data'))[selectedProject].annotations[0].entities : [];

    
    setUnusedEntitiesNames(allEntities.filter((item) => !usedEntitiesNames.includes(item)));
    setLoadPages(false) ;
  }, [loadPages,selectedProject]);

  return (
    <div
      className={clsx('blueBorderStyle', 'flexPropsDataCanvas')}
      style={{ backgroundColor: 'white', display: 'flex', flexDirection: 'column' }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          width: '100%',
          flexGrow: '3',
          marginBottom: '100px'
        }}
      >
        {uniqueDataElements.map((data) => (
          <DataCard  data={data} />
        ))}
      </div>
      {unusedEntitiesNames.length > 0 && <h2 style={{color: '#0c4d82', alignSelf: 'center', marginBottom: '10px'}}>You also have created some entities that you are not using</h2>
        }
      
      {unusedEntitiesNames && <div
      style={{
        height: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        
      }}>
        {unusedEntitiesNames.map((data) => (
          <UnusedDataCard  data={data} setUnusedEntitiesNames={setUnusedEntitiesNames} unusedEntities={unusedEntitiesNames} selectedProject={selectedProject}/>
        ))}
      </div>}
      
    </div>
  );
};

export default ProjectDataModelCanvas;
